// Shared leave-type options for Teacher form + Head Teacher review board.
// Keep in sync with backend LeaveRequest.leave_type values.
export const LEAVE_TYPES = [
  { value: 'casual', label: 'Casual Leave', color: 'bg-blue-100 text-blue-700 border-blue-300' },
  { value: 'sick', label: 'Sick Leave', color: 'bg-red-100 text-red-700 border-red-300' },
  { value: 'annual', label: 'Annual / Earned Leave', color: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
  { value: 'personal', label: 'Personal Leave', color: 'bg-purple-100 text-purple-700 border-purple-300' },
  { value: 'maternity', label: 'Maternity Leave', color: 'bg-pink-100 text-pink-700 border-pink-300' },
  { value: 'paternity', label: 'Paternity Leave', color: 'bg-indigo-100 text-indigo-700 border-indigo-300' },
  { value: 'bereavement', label: 'Bereavement Leave', color: 'bg-gray-200 text-gray-800 border-gray-400' },
  { value: 'duty', label: 'On Duty (official)', color: 'bg-amber-100 text-amber-700 border-amber-300' },
  { value: 'other', label: 'Other', color: 'bg-slate-100 text-slate-700 border-slate-300' },
];

export const LEAVE_TYPE_LABELS = Object.fromEntries(LEAVE_TYPES.map(t => [t.value, t.label]));
export const LEAVE_TYPE_COLORS = Object.fromEntries(LEAVE_TYPES.map(t => [t.value, t.color]));
